import { useUserActivePlansStatus } from "./Plan/useUserActivePlansStatus.ts";
import { shouldHideGroupSections } from "../UI/Layout/shouldHideGroupSections.ts";

export function useShouldHideGroupSections() {
  const { hasActive1on1Plan, hasActiveGroupPlan, loading } =
    useUserActivePlansStatus();

  return {
    shouldHide: shouldHideGroupSections({
      hasActive1on1Plan,
      hasActiveGroupPlan,
    }),
    hasActive1on1Plan,
    loading,
  };
}
